"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMCId = void 0;
var CMCId;
(function (CMCId) {
    CMCId[CMCId["XPNET"] = 11752] = "XPNET";
    CMCId[CMCId["EGLD"] = 6892] = "EGLD";
    CMCId[CMCId["HT"] = 2502] = "HT";
    CMCId[CMCId["BNB"] = 1839] = "BNB";
    CMCId[CMCId["ETH"] = 1027] = "ETH";
    CMCId[CMCId["AVAX"] = 5805] = "AVAX";
    CMCId[CMCId["MATIC"] = 3890] = "MATIC";
    CMCId[CMCId["FTM"] = 3513] = "FTM";
    CMCId[CMCId["ONE"] = 3945] = "ONE";
    CMCId[CMCId["TRX"] = 1958] = "TRX";
    CMCId[CMCId["CELO"] = 5567] = "CELO";
    CMCId[CMCId["ONT"] = 2566] = "ONT";
    CMCId[CMCId["XDAI"] = 8635] = "XDAI";
    CMCId[CMCId["ALGO"] = 4030] = "ALGO";
    CMCId[CMCId["FUSE"] = 5634] = "FUSE";
    CMCId[CMCId["XTZ"] = 2011] = "XTZ";
    CMCId[CMCId["VLX"] = 4747] = "VLX";
    CMCId[CMCId["IOTX"] = 2777] = "IOTX";
    CMCId[CMCId["AURORA"] = 1027] = "AURORA";
    CMCId[CMCId["VET"] = 3077] = "VET";
    CMCId[CMCId["CKB"] = 4948] = "CKB";
    CMCId[CMCId["GT"] = 4269] = "GT";
    CMCId[CMCId["SCRT"] = 5604] = "SCRT";
    CMCId[CMCId["SOL"] = 5426] = "SOL";
    CMCId[CMCId["TON"] = 11419] = "TON";
    CMCId[CMCId["ICP"] = 8916] = "ICP";
    CMCId[CMCId["HBAR"] = 4642] = "HBAR";
    CMCId[CMCId["sFUEL"] = 11735] = "sFUEL";
})(CMCId = exports.CMCId || (exports.CMCId = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ01DSWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kZWwvY29pbm1hcmtldGNhcC9DTUNJZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLEtBNkJYO0FBN0JELFdBQVksS0FBSztJQUNiLHVDQUFhLENBQUE7SUFDYixvQ0FBVyxDQUFBO0lBQ1gsZ0NBQVMsQ0FBQTtJQUNULGtDQUFVLENBQUE7SUFDVixrQ0FBVSxDQUFBO0lBQ1Ysb0NBQVcsQ0FBQTtJQUNYLHNDQUFZLENBQUE7SUFDWixrQ0FBVSxDQUFBO0lBQ1Ysa0NBQVUsQ0FBQTtJQUNWLGtDQUFVLENBQUE7SUFDVixvQ0FBVyxDQUFBO0lBQ1gsa0NBQVUsQ0FBQTtJQUNWLG9DQUFXLENBQUE7SUFDWCxvQ0FBVyxDQUFBO0lBQ1gsb0NBQVcsQ0FBQTtJQUNYLGtDQUFVLENBQUE7SUFDVixrQ0FBVSxDQUFBO0lBQ1Ysb0NBQVcsQ0FBQTtJQUNYLHdDQUFhLENBQUE7SUFDYixrQ0FBVSxDQUFBO0lBQ1Ysa0NBQVUsQ0FBQTtJQUNWLGdDQUFTLENBQUE7SUFDVCxvQ0FBVyxDQUFBO0lBQ1gsa0NBQVUsQ0FBQTtJQUNWLG1DQUFXLENBQUE7SUFDWCxrQ0FBVSxDQUFBO0lBQ1Ysb0NBQVcsQ0FBQTtJQUNYLHVDQUFhLENBQUE7QUFDakIsQ0FBQyxFQTdCVyxLQUFLLEdBQUwsYUFBSyxLQUFMLGFBQUssUUE2QmhCIn0=